var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.1665H6.66668M8.33334 12.4998H6.66668M13.3333 5.83317H6.66668M16.6667 5.6665V14.3332C16.6667 15.7333 16.6667 16.4334 16.3942 16.9681C16.1545 17.4386 15.7721 17.821 15.3017 18.0607C14.7669 18.3332 14.0668 18.3332 12.6667 18.3332H7.33334C5.93321 18.3332 5.23315 18.3332 4.69837 18.0607C4.22796 17.821 3.84551 17.4386 3.60583 16.9681C3.33334 16.4334 3.33334 15.7333 3.33334 14.3332V5.6665C3.33334 4.26637 3.33334 3.56631 3.60583 3.03153C3.84551 2.56112 4.22796 2.17867 4.69837 1.93899C5.23315 1.6665 5.93321 1.6665 7.33334 1.6665H12.6667C14.0668 1.6665 14.7669 1.6665 15.3017 1.93899C15.7721 2.17867 16.1545 2.56112 16.3942 3.03153C16.6667 3.56631 16.6667 4.26637 16.6667 5.6665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentLines);
export default __webpack_public_path__ + "static/media/document-lines.4a037fefddfafa7061b2cad2d63a004b.svg";
export { ForwardRef as ReactComponent };